import { Modal } from "antd";

function CustomModal({ children, ...props }) {
  return (
    <Modal
      transitionName=""
      width={1017}
      footer={null}
      bodyStyle={{ padding: 0, overflow: "auto" }}
      closable={false}
      maskStyle={{ backdropFilter: "blur(10px)" }}
      {...props}
    >
      {children}
    </Modal>
  );
}

export default CustomModal;
